import { InstanceStatus } from "@/components/instance/InstanceStatus";
import { useFormatter } from "@/hooks/useFormatter";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { ResourceListLayout } from "@/layouts/ResourceListLayout";
import { PoolsActions, PoolsDetailTabs } from "@/resources-def/pools-comp";
import { useTranslation } from "react-i18next";

const RESOURCE = 'pools';

export const PoolPage = () => {
  const { t } = useTranslation();
  const navigate = useResourceNavigate();
  const { formatDateTime } = useFormatter();

  const navigateToDetail = (record, e) => {
    e.preventDefault();
    navigate({ resource: RESOURCE, key: record.id, action: 'show' });
  };

  const columns = [
    { title: t("instances.fields.name"), dataIndex: "name" },
    { title: t("instances.fields.id"), dataIndex: "id", render: (text, record) => <a onClick={(e) => navigateToDetail(record, e) }>{text}</a> },
    { title: t("instances.fields.status"), dataIndex: "status", render:(value) => <InstanceStatus status={value} /> },
    { title: t("instances.fields.type"), dataIndex: "type" },
    { title: t("pools.fields.capacity"), dataIndex: "capacity" },
    { title: t("pools.fields.usages"), dataIndex: "usages" },
    { title: t("pools.fields.region"), dataIndex: "region" },
    { title: t("pools.fields.zone"), dataIndex: "zone" },
    { title: t("pools.fields.nodegroup"), dataIndex: "nodegroup" },
    { title: t("instances.fields.nodestatus"), dataIndex: "node_status", render:(value) => <InstanceStatus status={value} /> },
    { title: t("instances.fields.created_on"), dataIndex: "created_on", render: (value) => formatDateTime(value) },
    { title: t("instances.fields.created_by"), dataIndex: "created_by" }
  ];

  return (
    <ResourceListLayout
      resource={RESOURCE}
      actions={PoolsActions}
      columns={columns}
      details={PoolsDetailTabs()}
    >
    </ResourceListLayout>
  );
};